import {
  AfterViewInit,
  ChangeDetectionStrategy,
  ChangeDetectorRef,
  Component,
  ContentChild,
  CUSTOM_ELEMENTS_SCHEMA,
  ElementRef,
  inject,
  Input,
  PLATFORM_ID,
  signal,
  Signal,
  TemplateRef,
  ViewChild,
} from '@angular/core';
import { DestinationCardComponent } from '../../cards/destination-card/destination-card.component';
import { SwiperOptions } from 'swiper/types';
import { toSignal } from '@angular/core/rxjs-interop';
import { map, startWith } from 'rxjs';
import { ButtonComponent } from '../../buttons/button/button.component';
import { CarouselNavigationComponent } from '../../carousels/carousel-navigation/carousel-navigation.component';
import { SectionTitleComponent } from '../../ui-elements/section-title/section-title.component';
import { TravellerStoryCardComponent } from '../../cards/traveller-story-card/traveller-story-card.component';
import { HomeService } from '../../../../components/home/home.service';

import { selectTravellerStories } from '../../../../components/home/redux/selectors/home.selectors';
import { Store } from '@ngrx/store';
import { CommonModule, isPlatformBrowser, NgClass } from '@angular/common';
import { Router } from '@angular/router';
import { DiariesCardComponent } from '../../diaries-card/diaries-card.component';

@Component({
  selector: 'app-hotel-diaries',
  standalone: true,
  imports: [
    DestinationCardComponent,
    ButtonComponent,
    CarouselNavigationComponent,
    SectionTitleComponent,
    TravellerStoryCardComponent,
    NgClass,
    CommonModule,
    DiariesCardComponent,
  ],
  templateUrl: './hotel-diaries.component.html',
  styleUrl: './hotel-diaries.component.scss',
  schemas: [CUSTOM_ELEMENTS_SCHEMA],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class HotelDiariesComponent implements AfterViewInit {
  selectedType: string = 'domestic';
  private cdr = inject(ChangeDetectorRef);
  private homeService = inject(HomeService);
  private store = inject(Store);
  private platformId = inject(PLATFORM_ID);
  travellerStoriesState: Signal<{ travellerStories: any[] }> = signal({
    travellerStories: [],
  });
  @Input() customBreakpoints: any;
  activeIndex: number = 0;
  isBeginning: boolean = true;
  isEnd: boolean = false;
  @ContentChild('navigationLeftContent')
  navigationLeftContent!: TemplateRef<any>;
  @ViewChild('swiperContainer', { static: false }) swiperContainer!: ElementRef;
  swiperInstance!: any;
  breakpoints: any = {
    320: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    480: {
      slidesPerView: 1,
      spaceBetween: 10,
    },
    640: {
      slidesPerView: 1,
      spaceBetween: 15,
    },
    768: {
      slidesPerView: 2,
      spaceBetween: 20,
    },
    1180: {
      slidesPerView: 3,
      spaceBetween: 20,
    },
  };

  swiperConfig: SwiperOptions = {
    init: true,
    loop: false,
    spaceBetween: 10,
    centeredSlides: false,
    on: {
      slideChange: () => this.updateNavigationState(),
    },
    mousewheel: {
      forceToAxis: true,
      thresholdTime: 500,
      thresholdDelta: 50,
    },
    breakpoints: this.breakpoints,
    grabCursor: false,
    freeMode: false,
    shortSwipes: true,
    longSwipes: true,
    pagination: {
      // el: '.swiper-pagination',
      clickable: true, // Makes the pagination dots clickable
      dynamicBullets: true,
    },
  };

  reviews: any = [
    // {
    //   id: 1,
    //   author: 'Jacob Fernandez',
    //   avatar: 'https://i.pravatar.cc/100?img=12',
    //   text: `Lorem ipsum dolor sit amet, consectetur adipiscing elit, sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.`,
    //   rating: 4,
    //   date: new Date('2025-01-18'),
    //   platform: 'tripadvisor',
    //   platformLogo: '/assets/images/icons/MMT-Diaries-icon.svg',
    // },
    // {
    //   id: 2,
    //   author: 'Jacob Fernandez',
    //   avatar: 'https://i.pravatar.cc/100?img=14',
    //   text: `Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
    //   rating: 4,
    //   date: new Date('2025-01-18'),
    //   platform: 'makemytrip',
    //   platformLogo: '/assets/images/icons/tripadvisor-Diaries-icon.svg',
    // },
    // {
    //   id: 3,
    //   author: 'Jacob Fernandez',
    //   avatar: 'https://i.pravatar.cc/100?img=18',
    //   text: `Quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
    //   rating: 4,
    //   date: new Date('2025-01-18'),
    //   platform: 'google',
    //   platformLogo: '/assets/images/icons/google-Diaries-icon.svg',
    // },
    // {
    //   id: 4,
    //   author: 'Jacob Fernandez',
    //   avatar: 'https://i.pravatar.cc/100?img=14',
    //   text: `Ut enim ad minim veniam, quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
    //   rating: 4,
    //   date: new Date('2025-01-18'),
    //   platform: 'makemytrip',
    //   platformLogo: '/assets/images/icons/MMT-Diaries-icon.svg',
    // },
    // {
    //   id: 5,
    //   author: 'Jacob Fernandez',
    //   avatar: 'https://i.pravatar.cc/100?img=18',
    //   text: `Quis nostrud exercitation ullamco laboris nisi ut aliquip ex ea commodo consequat.`,
    //   rating: 4,
    //   date: new Date('2025-01-18'),
    //   platform: 'google',
    //   platformLogo: '/assets/images/icons/tripadvisor-Diaries-icon.svg',
    // },
  ];

  travelStories: any = [];
  isBrowser: boolean;
  constructor(private router: Router) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.fetchDiaries();
    }
  }

  ngAfterViewInit(): void {
    if (this.isBrowser) {
      this.swiperConfig.breakpoints =
        this.customBreakpoints || this.breakpoints;
      this.initSwiper();
      this.cdr.detectChanges();
    }
  }

  initSwiper() {
    Object.assign(this.swiperContainer.nativeElement, this.swiperConfig);
    this.swiperContainer.nativeElement.initialize();
    this.swiperInstance = this.swiperContainer.nativeElement.swiper;

    if (this.swiperInstance?.autoplay) {
      this.swiperInstance.autoplay.start();

      this.updateNavigationState();
      this.cdr.detectChanges();
    }
  }

  updateNavigationState() {
    if (this.swiperInstance) {
      this.activeIndex = this.swiperInstance.activeIndex;
      this.isBeginning = this.swiperInstance.isBeginning;
      this.isEnd = this.swiperInstance.isEnd;
      this.cdr.detectChanges();
    }
  }

  pauseAutoplay() {
    this.swiperInstance.autoplay.stop();
  }

  resumeAutoplay() {
    this.swiperInstance.autoplay.start();
  }

  fetchDiaries(): void {
    this.homeService.getAllReviews().subscribe((data: any) => {
      this.reviews = data;
      this.cdr.detectChanges();
    });
  }
}
